<div class="bn-manage-case-goals-dialog flex flex-col gap-4">
  <header class="bn-manage-case-goals-dialog__header">
    <h2 class="bn-manage-case-goals-dialog__title m-0">
      Manage goals for this case
    </h2>
  </header>

  <fieldset
    class="border-0 p-0 m-0 min-w-0 flex flex-col gap-4"
    [disabled]="saving() || liveSaveStarted()"
  >
    @if (store.activeGoals().length === 0 && draftGoals().length === 0) {
      <p class="text-sm text-surface-500 m-0">No active client goals yet.</p>
    } @else if (store.activeGoals().length > 0) {
      <fieldset class="flex flex-col gap-1 border-0 p-0 m-0">
        <legend class="bn-manage-case-goals-dialog__label p-0">
          Link to a client goal
        </legend>
        <div class="bn-manage-case-goals-dialog__goals flex flex-col gap-3">
          @for (goal of store.activeGoals(); track goal.id) {
            <div class="flex items-center gap-2 text-sm text-surface-700">
              <p-checkbox
                [inputId]="'mcg-goal-' + goal.id"
                [binary]="true"
                [ngModel]="selectedGoalIds().includes(goal.id)"
                (ngModelChange)="toggleGoal(goal.id, $event)"
              />
              <label [for]="'mcg-goal-' + goal.id">{{
                goal.displayText
              }}</label>
            </div>
          }
        </div>
      </fieldset>
    }

    @for (text of draftGoals(); track $index; let i = $index) {
      <div class="bn-manage-case-goals-dialog__draft flex items-start gap-2">
        <textarea
          pTextarea
          rows="2"
          maxlength="200"
          placeholder="What the client actually wants, in their words"
          [attr.aria-label]="'New goal ' + (i + 1)"
          [ngModel]="text"
          (ngModelChange)="setDraftText(i, $event)"
        ></textarea>
        <button
          type="button"
          class="bn-manage-case-goals-dialog__action"
          (click)="removeDraftRow(i)"
        >
          Remove
        </button>
      </div>
    }

    @if (!atCap()) {
      <button
        type="button"
        class="bn-manage-case-goals-dialog__add"
        (click)="addDraftRow()"
      >
        + {{ draftGoals().length > 0 ? 'Add another goal' : 'Capture goal' }}
      </button>
    }
  </fieldset>
  @if (saveError(); as message) {
    <p role="alert" class="text-sm m-0">{{ message }}</p>
  }
  <footer class="flex items-center justify-end gap-3">
    <button
      type="button"
      class="bn-manage-case-goals-dialog__cancel"
      (click)="tryClose()"
    >
      Cancel
    </button>
    <p-button
      label="Save"
      [rounded]="true"
      [loading]="saving()"
      [disabled]="
        saving() ||
        ambiguousCreate() ||
        (store.isLive() && !store.canManageGoals())
      "
      (onClick)="save()"
    />
  </footer>
</div>

<p-confirmDialog />
